import {combineReducers} from "redux";
import {UserReducer} from "@fkhplus/common/src/modules/user/reducer";
import {ThemeReducer} from "@fkhplus/common/src/modules/theme/reducer";
import { NetworkReducer } from "@fkhplus/common/src/modules/network/reducer";

export const appReducer = combineReducers({
    user: UserReducer,
    theme: ThemeReducer,
    network: NetworkReducer
});
